import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsernameHeaderComponent } from './username-header.component';
import {
  NgxBootstrapIconsModule,
  arrowRightShort,
  asterisk,
  bell,
  check,
  exclamationSquareFill,
  exclamationTriangle,
  pencilSquare,
  search,
  shield,
} from 'ngx-bootstrap-icons';
import {
  IconModule,
  StackedIconModule,
  alertError,
  uswdsDoNotDisturb,
} from '@gsa-sam/ngx-uswds-icons';

@NgModule({
  declarations: [UsernameHeaderComponent],
  exports: [UsernameHeaderComponent],
  imports: [
    CommonModule,
    IconModule,
    StackedIconModule,
    NgxBootstrapIconsModule.pick({
      pencilSquare,
      bell,
      shield,
      check,
      asterisk,
      arrowRightShort,
      search,
      uswdsDoNotDisturb,
      alertError,
      exclamationTriangle,
      exclamationSquareFill,
    }),
  ]
})
export class UsernameHeaderModule {}
